import { render, staticRenderFns } from "./audittrail.vue?vue&type=template&id=763af862"
import script from "./audittrail.vue?vue&type=script&lang=js"
export * from "./audittrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports